<template>
  <div class="bottomSetting shopping" @click.prevent="goHomeShopping">모바일 주문</div>
</template>

<script>
export default {
  name: 'HomeShoppingOrder',
  props: {
    homeShoppingChInfo: {
      type: Object
    }
  },
  methods: {
    goHomeShopping () {
      console.log('homeShoppingChInfo.orderurl 1 : ', this.homeShoppingChInfo.orderurl)
      if (this.homeShoppingChInfo.orderurl !== '') {
        console.log('homeShoppingChInfo.orderurl 2 : ', 'http://' + this.homeShoppingChInfo.orderurl)
        // location.href = 'http://' + this.homeShoppingChInfo.orderurl
        window.open('http://' + this.homeShoppingChInfo.orderurl)
      }
    }
  }
}
</script>

<style>
  .bottomSetting.shopping {
    font-size: 16px;
    background: #1351f9;
    height: 48px;
    text-align: center;
    vertical-align: middle;
    line-height: 48px;
    position: absolute;
    bottom: 0px;
    left: 0px;
    z-index: 10000;
    width: 100%;
    color: #fff;
    position: fixed;
  }
</style>
